<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">标段列表</h2>
            </div>

        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">标段名称:</label>
                <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
            <div style="display: flex; align-items: center;">
                <!-- <el-button type="primary" icon="el-icon-bottom" @click="handleExport">导出所有标段报名单位</el-button> -->
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加标段（包）</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>

        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidSectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />

                <el-table-column prop="bidSectionInvestmentEstimate" label="标段投资概算(元)" align="right" />
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getDocumentStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.canEdit && scope.row.status == 1" type="text" size="small"
                            @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleDelete(scope.row)" class="action-btn"
                            v-if="scope.row.status != 1">
                            删除
                        </el-button>
                        <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn"
                            v-if="scope.row.status != 1">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 标段详情弹窗 -->
        <el-dialog title="标段信息" :visible.sync="dialogs.detail" width="1200px" custom-class="section-detail-dialog"
            :append-to-body='true'>
            <div class="section-detail-content">
                <div class="detail-section-card">
                    <div class="detail-section-title">基础信息</div>
                    <div class="detail-grid">
                        <div class="detail-item half">
                            <label class="detail-label">项目名称</label>
                            <span class="detail-value">{{ sectionDetail.projectName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">项目编号</label>
                            <span class="detail-value">{{ sectionDetail.projectCode || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">标段名称</label>
                            <span class="detail-value">{{ sectionDetail.bidSectionName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">标段编号</label>
                            <span class="detail-value">{{ sectionDetail.bidSectionCode || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">评审形式</label>
                            <span class="detail-value">{{ getBlindReviewText(sectionDetail.isBlindReview) }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">阶段</label>
                            <span class="detail-value">{{ sectionDetail.stage === 1 ? '资格预审正式阶段' : '资格后审/资格预审预审阶段'
                                }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">是否报名</label>
                            <span class="detail-value">{{ sectionDetail.isNeedRegister === 1 ? '是' : '否' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">是否使用CA</label>
                            <span class="detail-value">{{ sectionDetail.issuanceUseCa === 1 ? '是' : '否' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">行业分类</label>
                            <span class="detail-value">{{ sectionDetail.industryName || '-' }}</span>
                        </div>
                        <div class="detail-item full" v-if="sectionDetail.bidSectionContent">
                            <label class="detail-label">标段内容</label>
                            <span class="detail-value multiline">{{ sectionDetail.bidSectionContent }}</span>
                        </div>
                        <div class="detail-item full" v-if="sectionDetail.bidderQualification">
                            <label class="detail-label">投标人资格条件</label>
                            <span class="detail-value multiline">{{ sectionDetail.bidderQualification }}</span>
                        </div>
                    </div>
                </div>

                <div class="detail-section-card">
                    <div class="detail-section-title">费用信息</div>
                    <div class="detail-grid">
                        <div class="detail-item half">
                            <label class="detail-label">投资概算</label>
                            <span class="detail-value">{{ sectionDetail.bidSectionInvestmentEstimate || 0 }} {{
                                getPriceUnitText(sectionDetail.priceUnit) }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">标书费</label>
                            <span class="detail-value">{{ sectionDetail.tenderFee || '未设置' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">图纸押金</label>
                            <span class="detail-value">{{ sectionDetail.drawingDepositFee || '未设置' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">平台技术服务费</label>
                            <span class="detail-value">{{ sectionDetail.platformServiceCharge || '未设置' }}</span>
                        </div>
                        <div class="detail-item full">
                            <label class="detail-label">招标文件缴费说明</label>
                            <span class="detail-value multiline">{{ sectionDetail.paymentInstructions || '-' }}</span>
                        </div>
                    </div>
                </div>

                <div class="detail-section-card">
                    <div class="detail-section-title">其他信息</div>
                    <div class="detail-grid">
                        <div class="detail-item half">
                            <label class="detail-label">创建时间</label>
                            <span class="detail-value">{{ sectionDetail.createTime || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <label class="detail-label">修改时间</label>
                            <span class="detail-value">{{ sectionDetail.modifyTime || '-' }}</span>
                        </div>
                    </div>
                </div>

                <div class="detail-section-card" v-if="sectionDetail.isNeedRegister === 1">
                    <div class="detail-section-title">报名资料</div>
                    <el-table :data="sectionDetail.bidSectionRegistrationList || []" border size="small"
                        class="detail-registration-table">
                        <el-table-column label="#" width="60" align="center">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="registrationName" label="资料名称" min-width="180" show-overflow-tooltip />
                        <el-table-column prop="registrationDescription" label="资料描述" min-width="220"
                            show-overflow-tooltip />
                        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
                        <el-table-column prop="createTime" label="创建时间" width="180" />
                        <el-table-column label="状态" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="getStatusType(scope.row.status)">{{
                                    getStatusText(scope.row.status) }}</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>

        <!-- 添加/修改标段弹窗 -->
        <el-dialog :title="editMode.isEdit ? '修改标段' : '添加标段'" :visible.sync="dialogs.add" width="1000px"
            custom-class="audit-dialog bid-section-dialog" :append-to-body='true'>
            <el-form :model="bidSectionForm" :rules="formRules" ref="bidSectionForm" label-width="180px"
                class="add-form">
                <!-- 招标项目名称 -->
                <el-form-item label="招标项目名称" prop="projectName" required>
                    <el-input v-model="bidSectionForm.projectName" placeholder="请输入招标项目名称" disabled />
                </el-form-item>

                <!-- 标段(包)名称 -->
                <el-form-item label="标段(包)名称" prop="bidSectionName" required>
                    <el-input v-model="bidSectionForm.bidSectionName" placeholder="请输入标段(包)名称" />
                </el-form-item>

                <!-- 标段(包)投资概算 -->
                <el-form-item label="标段(包)投资概算" prop="bidSectionInvestmentEstimate" required>
                    <el-input v-model="bidSectionForm.bidSectionInvestmentEstimate" placeholder="请输入标段(包)投资概算">
                        <template slot="append">元(人民币)</template>
                    </el-input>
                </el-form-item>

                <!-- 标书费(元) -->
                <el-form-item label="标书费(元)" prop="tenderFee">
                    <el-input v-model="bidSectionForm.tenderFee" placeholder="请输入标书费" />
                </el-form-item>

                <!-- 图纸押金(元) -->
                <el-form-item label="图纸押金(元)" prop="drawingDepositFee">
                    <el-input v-model="bidSectionForm.drawingDepositFee" placeholder="请输入图纸押金" />
                </el-form-item>

                <!-- 行业分类 -->
                <el-form-item label="行业分类" prop="industry" required>
                    <div v-if="editMode.isEdit && !showIndustryCascader" class="industry-display-row">
                        <el-input v-model="bidSectionForm.industryName" placeholder="请输入行业分类名称" />
                        <el-button type="text" @click="enableIndustrySelect">重新选择</el-button>
                    </div>
                    <el-cascader v-else :key="industryCascaderKey" ref="industryCascader"
                        v-model="bidSectionForm.industry" placeholder="请选择行业分类" :props="industryProps"
                        @change="handleIndustryChange" style="width: 100%;" clearable />
                </el-form-item>

                <!-- 招标文件缴费说明 -->
                <el-form-item label="招标文件缴费说明">
                    <el-input type="textarea" v-model="bidSectionForm.paymentInstructions"
                        placeholder="可选填,投标人缴纳标书款时可见,如缴费方式等" :rows="3" />
                </el-form-item>

                <!-- 投标人资格条件 -->
                <el-form-item label="投标人资格条件" prop="bidderQualification" required>
                    <el-input type="textarea" v-model="bidSectionForm.bidderQualification" placeholder="请输入投标人资格条件"
                        :rows="3" />
                </el-form-item>
                <!-- 评审形式 -->
                <el-form-item label="评审形式" prop="isBlindReview" required>
                    <el-radio-group v-model="bidSectionForm.isBlindReview">
                        <el-radio :label="0">明标</el-radio>
                        <el-radio :label="1">暗标</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 是否双信封（仅交通项目显示） -->
                <el-form-item label="是否使用双信封" prop="isDoubleEnvelope" v-if="projectDetail.isTraffic === 1">
                    <el-radio-group v-model="bidSectionForm.isDoubleEnvelope">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 是否使用CA -->
                <el-form-item label="是否使用CA" prop="issuanceUseCa" required>
                    <el-radio-group v-model="bidSectionForm.issuanceUseCa">
                        <el-radio :label="1">使用</el-radio>
                        <el-radio :label="0">不使用</el-radio>

                    </el-radio-group>
                </el-form-item>

                <!-- 是否需要投标人报名-->
                <el-form-item label="是否需要投标人报名" prop="isNeedRegister" required>
                    <el-radio-group v-model="bidSectionForm.isNeedRegister">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>


                <!-- 报名资料表格 - 当选择"是"时显示 -->
                <el-form-item v-if="bidSectionForm.isNeedRegister === 1" label="报名资料"
                    class="registration-materials-section">
                    <div class="registration-materials-table">
                        <el-table :data="registrationMaterials" border style="width: 100%" size="small">
                            <el-table-column prop="id" label="#" width="60" align="center" />
                            <el-table-column label="资料名称" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isEditing" v-model="scope.row.registrationName"
                                        placeholder="名称" size="small" />
                                    <span v-else>{{ scope.row.registrationName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="资料描述" min-width="120">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isEditing" v-model="scope.row.registrationDescription"
                                        placeholder="资料描述" size="small" />
                                    <span v-else>{{ scope.row.registrationDescription }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" min-width="120">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.isEditing" v-model="scope.row.remark" placeholder="备注"
                                        size="small" />
                                    <span v-else>{{ scope.row.remark }}</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="必传" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-checkbox v-if="scope.row.isEditing"
                                        v-model="scope.row.isRequired">是</el-checkbox>
                                    <span v-else>{{ scope.row.isRequired ? '是' : '否' }}</span>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="操作" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.isEditing" type="text" size="small"
                                        @click="saveMaterial(scope.row)" class="action-btn">
                                        保存
                                    </el-button>
                                    <template v-else>
                                        <el-button v-if="scope.row.id > 1" type="text" size="small"
                                            @click="deleteMaterial(scope.$index)" class="action-btn">
                                            删除
                                        </el-button>
                                        <el-button type="text" size="small" @click="addMaterial" class="action-btn">
                                            +添加
                                        </el-button>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form-item>

                <!-- 自动生成标段数量 -->
                <el-form-item label="自动生成标段数量" prop="bidSectionCount" required>
                    <el-input-number v-model="bidSectionForm.bidSectionCount" :min="0" :max="10"
                        controls-position="right" />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleSubmit(0)" :loading="operationStatus.isSubmitting">暂存</el-button>
                <el-button type="primary" @click="handleSubmit(1)" :loading="operationStatus.isSubmitting">
                    提交
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getProjectDetail, getBidSectionList, addBidSection, getBidSectionDetail, deleteBidSection, getBidRegistrationList } from '@/api/modules/agent'
import { getNextLevelData } from '@/api/modules/base'
import { getProjectTypeName } from '@/utils/base'
import RegionUtils from '@/utils/regionUtils'


export default {
    name: 'PoliticsProjectCreate',
    data() {
        return {
            // 页面基础信息
            pageTitle: '',
            projectCode: '',

            // 项目详情数据
            projectDetail: {},

            // 加载状态
            loading: false,

            // 搜索表单
            searchForm: {
                bidSectionName: ''
            },

            // 表格数据
            tableData: [],

            // 分页信息
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },

            // 弹窗控制
            dialogs: {
                add: false,
                detail: false
            },

            // 编辑模式
            editMode: {
                isEdit: false,
                editRowIndex: -1,
                editData: null
            },

            // 标段详情数据
            sectionDetail: {
                projectName: '',
                bidSectionName: '',
                bidSectionContent: '',
                bidSectionInvestmentEstimate: 0,
                currencyCode: 'CNY',
                tenderFee: 0,
                paymentInstructions: '',
                bidderQualification: '',
                payingParty: '',
                drawingDepositFee: 0,
                platformServiceCharge: 0,
                isNeedRegister: 0,
                isBlindReview: 0,
                isSubcontract: 0,
                issuanceUseCa: 1,
                priceUnit: 0,
                status: 0,
                remark: ''
            },

            // 添加/编辑标段表单
            bidSectionForm: {
                projectName: '',
                projectCode: '',
                projectId: '',
                bidSectionName: '',
                bidSectionCode: '',
                bidSectionInvestmentEstimate: '',
                currencyCode: 'CNY',
                tenderFee: '',
                drawingDepositFee: '',
                paymentInstructions: '',
                bidderQualification: '',
                isNeedRegister: 0,
                isBlindReview: 0,
                isSubcontract: 0,
                issuanceUseCa: 1,
                isDoubleEnvelope: 0,
                priceUnit: 0,
                fileGuid: '',
                remark: '',
                status: 0,
                bidSectionCount: 1,
                // 行业分类相关字段
                industryCode: '',
                industryName: '',
                industry: []
            },
            // 表单验证规则
            formRules: {
                projectName: [
                    { required: true, message: '请输入招标项目名称', }
                ],
                bidSectionName: [
                    { required: true, message: '请输入标段(包)名称', },
                    { min: 2, max: 100, message: '标段名称长度在 2 到 100 个字符' }
                ],
                bidSectionInvestmentEstimate: [
                    { required: true, message: '请输入标段(包)投资概算' },
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入有效的金额' }
                ],
                tenderFee: [
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入有效的金额' }
                ],
                drawingDepositFee: [
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入有效的金额' }
                ],
                bidderQualification: [
                    { required: true, message: '请输入投标人资格条件' },
                    { min: 0, max: 2000, message: '资格条件长度在 0 到 2000 个字符' }
                ],
                isNeedRegister: [
                    { required: true, message: '请选择是否需要投标人报名', }
                ],
                issuanceUseCa: [
                    { required: true, message: '请选择是否使用CA', }
                ],
                isDoubleEnvelope: [
                    { required: true, message: '请选择是否双信封', }
                ],
                bidSectionCount: [
                    { required: true, message: '请选择标段数量', }
                ],
                industry: [
                    { required: true, message: '请选择行业分类', }
                ]
            },
            // 文件上传配置
            uploadConfig: {
                action: '/api/upload',
                fileList: []
            },

            // 报名资料管理
            registrationMaterials: [
                {
                    id: 1,
                    registrationName: '',
                    registrationDescription: '',
                    remark: '',
                    isRequired: true,
                    isEditing: true,
                    registrationGuid: '',
                    sectionId: null,
                    fileGuid: ''
                }
            ],

            // 操作状态
            operationStatus: {
                isSubmitting: false,
                isDeleting: false
            },

            // 行业分类选项
            industryOptions: [],

            // 行业级联选择器配置（固定配置，避免重复创建）
            industryProps: null,

            // 级联选择器 key（用于强制重新创建组件）
            industryCascaderKey: 0,

            // 行业回显模式：编辑时默认展示名称，点击后切换为级联选择器
            showIndustryCascader: true
        }
    },
    mounted() {
        this.initPage()
    },

    created() {
        // 行业级联选择器配置（懒加载模式）
        this.industryProps = RegionUtils.getCascaderProps('BID_SECTION_CLASSIFY_CODE')
    },

    methods: {
        // ==================== 页面初始化 ====================
        /**
         * 初始化页面
         */
        initPage() {
            const projectCode = this.$route.query.projectCode
            if (!projectCode) {
                this.$message.error('缺少项目编号参数')
                this.$router.go(-1)
                return
            }

            this.projectCode = projectCode
            this.loadProjectDetail()
            this.loadBidSectionList()
        },

        /**
         * 加载项目详情
         */
        async loadProjectDetail() {
            try {
                const res = await getProjectDetail({ projectCode: this.projectCode })
                if (res.code === 200) {
                    this.projectDetail = res.data
                    this.pageTitle = this.generatePageTitle(res.data)
                    this.initBidSectionForm(res.data)
                } else {
                    this.handleApiError(res, '获取项目详情失败')
                }
            } catch (error) {
                this.handleError(error, '获取项目详情失败')
            }
        },

        /**
         * 加载标段列表
         */
        async loadBidSectionList() {
            this.loading = true
            try {
                const params = this.buildSearchParams()
                const res = await getBidSectionList(params)
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.handleApiError(res, '获取标段列表失败')
                }
            } catch (error) {
                this.handleError(error, '获取标段列表失败')
            } finally {
                this.loading = false
            }
        },

        /**
         * 生成页面标题
         */
        generatePageTitle(projectData) {
            const projectTypeName = getProjectTypeName(projectData.projectType)
            return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
        },

        /**
         * 初始化标段表单
         */
        initBidSectionForm(projectData) {
            this.bidSectionForm.projectName = projectData.projectName
            this.bidSectionForm.projectCode = projectData.projectCode
            this.bidSectionForm.projectId = projectData.id
        },

        /**
         * 构建搜索参数
         */
        buildSearchParams() {
            return {
                projectCode: this.projectCode,
                bidSectionName: this.searchForm.bidSectionName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize
            }
        },

        /**
         * 获取价格单位文本
         */
        getPriceUnitText(priceUnit) {
            const unitMap = {
                0: '元',
                1: '万元',
                2: '%'
            }
            return unitMap[priceUnit] || '元'
        },

        getBlindReviewText(isBlindReview) {
            if (isBlindReview === 0) {
                return '明标'
            }
            if (isBlindReview === 1) {
                return '暗标'
            }
            return '-'
        },

        /**
         * 获取状态文本
         */
        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                2: '退回'
            }
            return statusMap[status] || '未知'
        },

        /**
         * 处理API错误
         */
        handleApiError(res, defaultMessage) {
            const message = res.msg || defaultMessage
            this.$message.error(message)
            console.error('API Error:', res)
        },

        /**
         * 处理通用错误
         */
        handleError(error, defaultMessage) {
            const message = error.message || defaultMessage
            this.$message.error(message)
            console.error('Error:', error)
        },

        /**
         * 搜索
         */
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadBidSectionList()
        },

        /**
         * 查看详情
         */
        async handleViewDetails(row) {
            try {
                const res = await getBidSectionDetail({ bidSectionCode: row.bidSectionCode })
                if (res.code === 200) {
                    this.sectionDetail = res.data
                    this.dialogs.detail = true
                    this.tableData = res.data
                } else {
                    this.handleApiError(res, '获取标段详情失败')
                }
            } catch (error) {
                this.handleError(error, '获取标段详情失败')
            }
        },

        /**
         * 查看报名单位
         */
        handleViewUnits(row) {
            // this.$notify({
            //     title: '操作失败',
            //     message: '报名单位不满足三家',
            //     type: 'warning',
            //     duration: 1500
            // })
        },
        async getBidRegistrationList() {
            this.loading = true
            try {
                const params = {
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                    status: 9,
                    projectCode: this.projectCode
                }
                const res = await getBidRegistrationList(params)
                if (res.code === 200) {
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            } catch (error) {
                console.error('获取列表失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }

        },

        /**
         * 删除确认
         */
        handleDelete(row) {
            this.$confirm('确定要删除该标段吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteBidSection(row)
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        // 编辑
        async handleEdit(row) {
            try {
                const res = await getBidSectionDetail({ bidSectionCode: row.bidSectionCode })
                if (res.code === 200) {
                    // 设置编辑模式
                    this.editMode.isEdit = true
                    this.editMode.editData = res.data

                    // 通过 industryCode 倒推完整路径
                    const industryPath = this.buildIndustryPath(res.data.industryCode)

                    // 填充表单数据
                    this.bidSectionForm = {
                        projectName: res.data.projectName || '',
                        projectCode: res.data.projectCode || '',
                        projectId: res.data.projectId || '',
                        bidSectionName: res.data.bidSectionName || '',
                        bidSectionCode: res.data.bidSectionCode || '',
                        bidSectionInvestmentEstimate: res.data.bidSectionInvestmentEstimate || '',
                        currencyCode: res.data.currencyCode || 'CNY',
                        tenderFee: res.data.tenderFee || '',
                        drawingDepositFee: res.data.drawingDepositFee || '',
                        paymentInstructions: res.data.paymentInstructions || '',
                        bidderQualification: res.data.bidderQualification || '',
                        isNeedRegister: res.data.isNeedRegister || 0,
                        isBlindReview: res.data.isBlindReview || 0,
                        isSubcontract: res.data.isSubcontract || 0,
                        issuanceUseCa: res.data.issuanceUseCa,
                        isDoubleEnvelope: res.data.isDoubleEnvelope != null ? res.data.isDoubleEnvelope : 0,
                        priceUnit: res.data.priceUnit || 0,
                        fileGuid: res.data.fileGuid || '',
                        remark: res.data.remark || '',
                        status: res.data.status || 0,
                        bidSectionCount: 1,
                        industryCode: res.data.industryCode || '',
                        industryName: res.data.industryName || '',
                        industry: industryPath
                    }

                    // 回显报名资料
                    const registrationList = Array.isArray(res.data.bidSectionRegistrationList)
                        ? res.data.bidSectionRegistrationList
                        : []
                    if (registrationList.length > 0) {
                        this.registrationMaterials = registrationList.map((item, index) => ({
                            id: index + 1,
                            registrationName: item.registrationName || '',
                            registrationDescription: item.registrationDescription || '',
                            remark: item.remark || '',
                            isRequired: item.isRequired === 1 || item.status === 1,
                            isEditing: false,
                            registrationGuid: item.registrationGuid || '',
                            sectionId: item.sectionId || res.data.id || null,
                            fileGuid: item.fileGuid || ''
                        }))
                    } else {
                        this.resetRegistrationMaterials()
                    }

                    // 编辑模式先展示行业名称，必要时再切换选择器
                    this.showIndustryCascader = false

                    // 强制重新创建级联选择器
                    this.industryCascaderKey++
                    // 打开弹窗
                    this.dialogs.add = true
                } else {
                    this.handleApiError(res, '获取标段详情失败')
                }
            } catch (error) {
                this.handleError(error, '获取标段详情失败')
            }
        },

        /**
         * 删除标段
         */
        async deleteBidSection(row) {
            this.operationStatus.isDeleting = true
            try {
                const res = await deleteBidSection({ bidSectionCode: row.bidSectionCode })
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadBidSectionList()
                } else {
                    this.handleApiError(res, '删除失败')
                }
            } catch (error) {
                this.handleError(error, '删除失败')
            } finally {
                this.operationStatus.isDeleting = false
            }
        },

        /**
         * 根据 industryCode 倒推完整路径
         * 例如: B010101 -> ['B', 'B01', 'B0101', 'B010101']
         */
        buildIndustryPath(industryCode) {
            if (!industryCode || typeof industryCode !== 'string') {
                return []
            }

            const path = []
            const code = industryCode.trim()

            // 第一级：单个字母 (B)
            if (code.length >= 1) {
                path.push(code.substring(0, 1))
            }

            // 第二级：字母 + 2位数字 (B01)
            if (code.length >= 3) {
                path.push(code.substring(0, 3))
            }

            // 第三级：字母 + 4位数字 (B0101)
            if (code.length >= 5) {
                path.push(code.substring(0, 5))
            }

            // 第四级：字母 + 6位数字 (B010101)
            if (code.length >= 7) {
                path.push(code.substring(0, 7))
            }

            return path
        },

        /**
         * 添加标段
         */
        handleAdd() {
            // 重置编辑模式
            this.editMode.isEdit = false
            this.editMode.editData = null
            this.resetBidSectionForm()
            this.showIndustryCascader = true
            this.industryCascaderKey++  // 强制重新创建级联选择器
            this.dialogs.add = true
        },

        enableIndustrySelect() {
            this.showIndustryCascader = true
            this.$nextTick(() => {
                this.industryCascaderKey++
            })
        },

        /**
         * 返回项目流程界面
         */
        handleBack() {
            this.$router.go(-1)
        },

        /**
         * 导出所有标段报名单位
         */
        handleExport() {
            this.$message.info('导出所有标段报名单位功能')
        },
        /**
         * 分页大小改变
         */
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.loadBidSectionList()
        },

        /**
         * 当前页改变
         */
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadBidSectionList()
        },

        /**
         * 行业选择变化处理
         */
        async handleIndustryChange(value) {
            await RegionUtils.handleRegionChange(
                value,
                this.$refs.industryCascader,
                this.bidSectionForm,
                {
                    provinceField: '',
                    provinceCodeField: '',
                    cityField: '',
                    cityCodeField: '',
                    countyField: 'industryName',
                    countyCodeField: 'industryCode',
                    regionField: 'industry',
                    enableDebug: false
                },
                this,
                'BID_SECTION_CLASSIFY_CODE'
            )
        },

        /**
         * 提交表单
         */
        handleSubmit(submitType) {
            this.$refs.bidSectionForm.validate((valid) => {
                if (valid) {
                    this.submitBidSection(submitType)
                } else {
                    this.$message.error('请填写必填项')
                }
            })
        },

        /**
         * 提交标段数据
         */
        async submitBidSection(submitType) {
            this.operationStatus.isSubmitting = true
            try {
                const formData = this.prepareFormData(submitType)
                delete formData.industry
                const res = await addBidSection(formData)
                if (res.code === 200) {
                    this.$message.success('提交成功')
                    this.dialogs.add = false
                    this.resetBidSectionForm()
                    this.loadBidSectionList()
                } else {
                    this.handleApiError(res, '提交失败')
                }
            } catch (error) {
                this.handleError(error, '提交失败')
            } finally {
                this.operationStatus.isSubmitting = false
            }
        },

        /**
         * 准备表单数据
         */
        prepareFormData(submitType) {
            const formData = { ...this.bidSectionForm }

            // 设置项目相关信息
            formData.projectCode = this.projectDetail.projectCode
            formData.projectId = this.projectDetail.id
            formData.projectName = this.projectDetail.projectName
            formData.status = submitType

            // 确保数值类型字段正确
            formData.bidSectionInvestmentEstimate = parseFloat(formData.bidSectionInvestmentEstimate) || 0
            formData.tenderFee = parseFloat(formData.tenderFee) || 0

            // 处理报名资料
            if (formData.isNeedRegister === 1) {
                formData.bidSectionRegistrationPoList = this.prepareRegistrationMaterials()
            } else {
                formData.bidSectionRegistrationPoList = []
            }

            return formData
        },

        /**
         * 准备报名资料数据
         */
        prepareRegistrationMaterials() {
            return this.registrationMaterials
                .filter(item => item.registrationName && item.registrationName.trim() !== '')
                .map(item => ({
                    registrationName: item.registrationName,
                    registrationDescription: item.registrationDescription || '',
                    remark: item.remark || '',
                    isRequired: item.isRequired ? 1 : 0,
                    registrationGuid: item.registrationGuid || '',
                    sectionId: item.sectionId || null,
                    fileGuid: item.fileGuid || ''
                }))
        },

        /**
         * 重置标段表单
         */
        resetBidSectionForm() {
            this.$refs.bidSectionForm && this.$refs.bidSectionForm.resetFields()
            this.editMode.isEdit = false
            this.editMode.editRowIndex = -1
            this.editMode.editData = null

            this.bidSectionForm = {
                projectName: this.projectDetail.projectName || '',
                projectCode: '',
                projectId: '',
                bidSectionName: '',
                bidSectionCode: '',
                bidSectionInvestmentEstimate: '',
                currencyCode: 'CNY',
                tenderFee: '',
                drawingDepositFee: '',
                paymentInstructions: '',
                bidderQualification: '',
                isNeedRegister: 0,
                isBlindReview: 0,
                isSubcontract: 0,
                issuanceUseCa: 1,
                isDoubleEnvelope: 0,
                priceUnit: 0,
                fileGuid: '',
                remark: '',
                status: 0,
                bidSectionCount: 1,
                // 行业分类相关字段
                industryCode: '',
                industryName: '',
                industry: []
            }

            this.showIndustryCascader = true
            this.resetRegistrationMaterials()
        },

        /**
         * 重置报名资料
         */
        resetRegistrationMaterials() {
            this.registrationMaterials = [
                {
                    id: 1,
                    registrationName: '',
                    registrationDescription: '',
                    remark: '',
                    isRequired: true,
                    isEditing: true,
                    registrationGuid: '',
                    sectionId: null,
                    fileGuid: ''
                }
            ]
        },
        /**
         * 添加新的报名资料
         */
        addMaterial() {
            const newId = Math.max(...this.registrationMaterials.map(item => item.id)) + 1
            this.registrationMaterials.push({
                id: newId,
                registrationName: '',
                registrationDescription: '',
                remark: '',
                isRequired: false,
                isEditing: true,
                registrationGuid: '',
                sectionId: null,
                fileGuid: ''
            })
        },

        /**
         * 保存报名资料
         */
        saveMaterial(row) {
            if (!row.registrationName.trim()) {
                this.$message.warning('请输入资料名称')
                return
            }
            row.isEditing = false
            this.$message.success('保存成功')
        },

        /**
         * 删除报名资料
         */
        deleteMaterial(index) {
            this.$confirm('确定要删除该报名资料吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.registrationMaterials.splice(index, 1)
                // 重新编号
                this.registrationMaterials.forEach((item, idx) => {
                    item.id = idx + 1
                })
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        getDocumentStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                2: '退回'
            }
            return statusMap[status] || '-'
        },

        getStatusType(status) {
            const statusMap = {
                1: 'success',
                0: 'info'

            }
            return statusMap[status] || 'info'
        },

        getStepSubmitText(stepSubmit) {
            const stepSubmitMap = {
                1: '已提交',
                2: '未提交'
            }
            return stepSubmitMap[stepSubmit] || '-'
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 弹窗样式
// ============================================
/deep/ .add-section-dialog,
/deep/ .section-detail-dialog {
    .minimal-dialog-styles();
}

// 添加标段弹窗
/deep/ .add-section-dialog {
    .add-form {
        .el-form-item {
            margin-bottom: 20px;

            .el-form-item__label {
                font-weight: 500;
                color: @gray-700;
            }

            .el-form-item__content {
                color: @gray-600;
            }
        }

        .el-radio-group .el-radio {
            margin-right: 20px;

            .el-radio__label {
                color: @gray-600;
            }

            &.is-checked .el-radio__label {
                color: @primary-color;
            }
        }

        .el-input-number {
            width: 100%;
        }
    }

    .dialog-footer {
        text-align: right;
        padding: 16px 0 0;
        border-top: 1px solid @gray-200;
        margin-top: 16px;

        .el-button {
            margin-left: 12px;
            transition: all 0.2s ease;

            &:hover {
                transform: translateY(-1px);
            }
        }
    }
}

// 标段详情弹窗
/deep/ .section-detail-dialog {
    .section-detail-content {
        max-height: 70vh;
        overflow-y: auto;
        padding-right: 4px;

        .detail-section-card {
            background: #fff;
            border: 1px solid @gray-200;
            border-radius: 8px;
            padding: 18px 20px;
            margin-bottom: 16px;

            .detail-section-title {
                font-size: 16px;
                font-weight: 600;
                color: @gray-800;
                margin-bottom: 16px;
                padding-left: 10px;
                border-left: 4px solid @primary-color;
            }

            .detail-grid {
                display: flex;
                flex-wrap: wrap;
                gap: 14px 24px;

                .detail-item {
                    display: flex;
                    align-items: flex-start;
                    line-height: 1.6;

                    &.half {
                        width: calc(50% - 12px);
                    }

                    &.full {
                        width: 100%;
                    }

                    .detail-label {
                        width: 120px;
                        flex-shrink: 0;
                        font-weight: 500;
                        color: @gray-700;
                    }

                    .detail-value {
                        flex: 1;
                        color: @gray-600;
                        word-break: break-all;

                        &.multiline {
                            white-space: pre-wrap;
                        }
                    }
                }
            }
        }

        .detail-registration-table {
            margin-top: 8px;
        }
    }
}

// 报名资料表格
.registration-materials-section {
    .registration-materials-table {
        .action-btn {
            .minimal-action-button-styles(#409EFF, #409EFF, 13px, 10px);
        }
    }
}

// ============================================
// 全局输入框优化
// ============================================
/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
    border-color: @gray-300;
    color: @gray-700;
    transition: all 0.2s ease;

    &:hover {
        border-color: @gray-400;
    }

    &:focus {
        border-color: @primary-color;
    }

    &::placeholder {
        color: @gray-400;
    }
}

// ============================================
// 标签优化
// ============================================
/deep/ .el-tag {
    border: none;
    font-weight: 500;

    &--success {
        background: fade(@success-color, 10%);
        color: @success-color;
    }

    &--warning {
        background: fade(@warning-color, 10%);
        color: @warning-color;
    }

    &--danger {
        background: fade(@error-color, 10%);
        color: @error-color;
    }

    &--info {
        background: @gray-100;
        color: @gray-600;
    }
}

// ============================================
// 层级管理
// ============================================
.bid-section-dialog {
    z-index: 2001;
}
</style>

<style>
/* 全局样式：弹窗蒙版层级 */
.v-modal {
    z-index: 2000;
    background-color: rgba(0, 0, 0, 0.4);
}

.el-dialog__wrapper.bid-section-dialog-wrapper {
    z-index: 2001;
}
</style>
